import { render } from "./QualityStats.vue?vue&type=template&id=765e60fc&ts=true"
import script from "./QualityStats.vue?vue&type=script&lang=ts"
export * from "./QualityStats.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__